// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dashboardtop-tile[data-v-acc5788c] .v-card__text h2 {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 38px;
}
.dashboardtop-tile[data-v-acc5788c] .v-card__title {
  width: calc(100% - 115px);
}
.dashboardtop-tile[data-v-acc5788c] .v-card {
  height: 120px !important;
  overflow: hidden;
}
.dashboardtop-tile[data-v-acc5788c] .chart-line {
  margin-top: 5px;
}
@media only screen and (max-width: 1200px) {
.dashboardtop-tile[data-v-acc5788c] .v-card__text h2 {
    font-size: 30px;
}
.dashboardtop-tile .request-info[data-v-acc5788c] .v-card {
    height: 100px !important;
}
.dashboardtop-tile .request-info[data-v-acc5788c] .v-card .v-card__title {
    width: calc(100% - 88px);
}
}
.dashboardtop-tile[data-v-acc5788c] .chart-line .chartjs-render-monitor {
  width: 100% !important;
}
.card-small-tile.v-card[data-v-acc5788c] {
  min-height: 75px;
}
.card-title-pre.v-card__title[data-v-acc5788c] {
  white-space: pre;
}
.day-counts-section[data-v-acc5788c] {
  padding: 15px 10px 8px;
}
.day-counts-section > div > span[data-v-acc5788c] {
  display: inline-block;
  padding: 0px 10px;
}
.day-counts-section > div > span[data-v-acc5788c]:last-child {
  padding-right: 0px;
}
.day-counts-section .count[data-v-acc5788c] {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  padding-left: 5px;
}
.day-counts-section .v-icon img[data-v-acc5788c] {
  height: 19px;
}
.big-size[data-v-acc5788c] {
  font-size: 38px;
}
.card-small-tile[data-v-acc5788c] .v-icon {
  vertical-align: middle;
  height: 12px;
}
.tooltip-filter[data-v-acc5788c] {
  position: absolute;
  top: 3px;
  right: 3px;
}
.finance-cards[data-v-acc5788c] {
  width: 20%;
  position: relative;
}
.finance-cards .card-small-tile[data-v-acc5788c] {
  height: 100%;
  padding-bottom: 58px !important;
}
.finance-cards[data-v-acc5788c] .card-small-tile + .day-counts-section {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 8px;
}
.tilecard-col[data-v-acc5788c] {
  max-width: 20% !important;
  flex-basis: 20% !important;
}
@media only screen and (max-width: 1440px) {
.finance-cards[data-v-acc5788c] .day-counts-section .count {
    font-size: 18px;
}
.finance-cards[data-v-acc5788c] .day-counts-section .v-icon {
    font-size: 20px !important;
}
.tilecard-col[data-v-acc5788c] {
    max-width: 33.33% !important;
    flex-basis: 33.33% !important;
}
}
@media only screen and (max-width: 1300px) {
.finance-cards[data-v-acc5788c] .day-counts-section .count {
    font-size: 16px;
}
.finance-cards[data-v-acc5788c] .day-counts-section .v-icon {
    font-size: 18px !important;
}
}
@media only screen and (max-width: 1200px) {
.m-supvr-rcol .day-counts-section > div > span[data-v-acc5788c] {
    padding: 0px 6px;
}
.finance-cards[data-v-acc5788c] {
    width: 50%;
    max-width: 50%;
}
}
/* @media only screen and (max-width: 959px) {
 .card-small-tile.v-card{
   margin-bottom: 10px;
 }
} */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
